import { Injectable } from '@angular/core';

import { AbstractControl } from '@angular/forms';
import { namePatterns } from '@com-delta-idp/mnx-utils';
import { regexList } from '../../../validator/regex-list';

@Injectable({
  providedIn: 'root'
})
export class ForgotLoginExtendedService {
  firstName_pattern_check_new(control: AbstractControl): {
    [s: string]: boolean;
  } {
    const value = control?.value?.value.trim();
    if (value && value.match(namePatterns.firstName)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
    return { INVALID_FIRSTNAME: true };
  }

  lastName_pattern_check_new(control: AbstractControl): {
    [s: string]: boolean;
  } {
    const value = control?.value?.value.trim();
    if (value && value.match(namePatterns.lastName)) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
    return { INVALID_LASTNAME: true };
  }

  firstName_pattern_check(control: AbstractControl): { [s: string]: boolean } {
    const value = control?.value?.value.trim();
    if (
      value &&
      value.match(regexList.firstNameLength) &&
      value.match(regexList.firstName)
    ) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
    return { INVALID_FIRSTNAME: true };
  }

  lastName_pattern_check(control: AbstractControl): { [s: string]: boolean } {
    const value = control?.value?.value.trim();
    if (
      value &&
      value.match(regexList.lastNameLength) &&
      value.match(regexList.lastName)
    ) {
      return <{ [s: string]: boolean }>(<unknown>null);
    }
    return { INVALID_LASTNAME: true };
  }
}
